import {gql} from '@apollo/client';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

export const FORM_INSTANCE_FILE_STATE_QUERY = gql`
  query FormInstanceFileStateQuery($formDefinitionId: StrictString!) @skipAudit @engComponent(name: FORMS) {
    formDefinition(id: $formDefinitionId) {
      ... on FormDefinitionNode {
        id
        name
        instanceUrl
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export const FORM_INSTANCE_QUERY = gql`
  query FormInstanceQuery($formDefinitionId: StrictString!) @skipAudit @engComponent(name: FORMS) {
    formDefinition(id: $formDefinitionId) {
      ... on FormDefinitionNode {
        id
        name
        latestFormDefinitionVersion {
          id
          definition {
            sections
          }
        }
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;
